import { getStore } from '../store/store';

/**
 * Whether the store is initialized or not
 */
export default function getIsCloudSettingsStoreInitialized(): boolean {
    return getStore().isInitialized;
}
